<template>
  <div>
      <a-modal class="" :title="title[kind]" :visible="pollutionVisible"  @cancel="closeVisible"  width="50%" @ok="submit" >
         <div class="containerTop">
            <a-form-model :model="polltion" ref="categoriesRef" >
                <a-row style="margin-top: 10px;">
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="所属项目"  prop="categoryName">
                            <span>{{polltion.categoryName}}</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="所属分类"  prop="subcategoryId">
                             <span v-if="kind==2">{{polltion.subcategory}}</span>
                            <a-select style="width: 100%;" allowClear placeholder="请选择污染物所属分类" v-model="polltion.subcategoryId" @change="changeSubCategory" 
                                 show-search :filter-option="filterOption" v-else :rules="{
								  required: true,
								  message: '请选择污染物所属分类',
								  trigger: 'change',
								}">
                                <a-select-option :value="item.categoryId" v-for="(item, index) in detailList" :key="index">
                                          {{ item.categoryName }}
                                </a-select-option>
                            </a-select>
                            
                        </a-form-model-item>
                    </a-col>
                </a-row>
                 <a-row style="margin-top: 10px;">
                    <a-col :span="12"  >
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="污染物名称"  prop="factorName" :rules="{
								  required: true,
								  message: '请填写污染物名称',
								  trigger: 'change',
								}">
                           <span v-if="kind==2">{{polltion.factorName}}</span>
                           <a-input v-else style="width: 100%;" v-model="polltion.factorName" allowClear placeholder="污染物名称" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="限制"  prop="limitRange">
                            <span v-if="kind==2">{{polltion.limitRange}}</span>
                            <a-input  v-else style="width: 100%;" v-model="polltion.limitRange" allowClear placeholder="限制" />
                          
                        </a-form-model-item>
                    </a-col>
                </a-row>
                 <a-row style="margin-top: 10px;">
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 3 }" class="model_span_form" :wrapper-col="{ span: 21}"
                            label="检测标准"  prop="standardInfo" :rules="{
								  required: true,
								  message: '请填写检测标准',
								  trigger: 'change',
								}">
                            <span v-if="kind==2">{{polltion.standardInfo}}</span>
                            <a-input  v-else style="width: 100%;" v-model="polltion.standardInfo" allowClear placeholder="检测标准" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                 <a-row style="margin-top: 10px;">
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="分析费"  prop="analysePrice" :rules="{
								  required: true,
								  message: '请填写分析费',
								  trigger: 'change',
								}">
                           <span v-if="kind==2">{{polltion.analysePrice}}</span>
                           <a-input  v-else style="width: 100%;" v-model="polltion.analysePrice" allowClear placeholder="污染物名称" @change="countPrice"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="采样费"  prop="samplePrice" :rules="{
								  required: true,
								  message: '请填写采样费',
								  trigger: 'change',
								}">
                            <span v-if="kind==2">{{polltion.samplePrice}}</span>
                            <a-input  v-else style="width: 100%;" v-model="polltion.samplePrice" allowClear placeholder="采样费" @change="countPrice"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                 <a-row style="margin-top: 10px;">
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="单价"  prop="price">
                            <span>{{polltion.price}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
               

            </a-form-model>
          </div>
      </a-modal>
  </div>
</template>

<script>
import { getChargeList, getPollotantList} from '@/api/surrounding'
import { editFactors_put, baseFactor_add } from '@/api/Industry'
export default {
    props: [
        'pollutionVisible',
        'kind',
        'polltion'
    ],
    data() {
        return {
            // polltion: {},
            title: [
                '新增污染物',
                '编辑污染物',
                '详情'
                ],
            detailList: []
        }
    },
    mounted() {
        this.getDetail()

        
    },
    methods:{
        countPrice() {
            if(this.polltion.analysePrice!= '' && this.polltion.analysePrice!= undefined && this.polltion.samplePrice !='' && this.polltion.samplePrice != undefined) {
            this.polltion.price = Number(this.polltion.analysePrice) + Number(this.polltion.samplePrice)
            }

        },
        changeSubCategory(e) {
            this.detailList.forEach(item => {
                if (item.categoryId == e) {
                    this.polltion.subcategory = item.categoryName
                }
            })

        },
        //表单提交事件
        submit() {
             Object.assign(this.polltion, {
                categoryId: 1001
            })
            
            if(this.kind == 0) {
                //新增
                this.$refs.categoriesRef.validate(valid => {
                 if(valid) {
                     baseFactor_add(this.polltion).then(res => {
                        if(res.code == 200) {
                            this.$message.success(res.msg)
                            this.$emit('getdata')
                             this.pollutionVisible = false
                            this.$emit('changePollutionVisible', this.pollutionVisible)
                            this.$refs.categoriesRef.resetFields()
                        } else {
                            this.$message.error(res.msg)

                        }
                     })
                }
            }) 

            } 
            if (this.kind == 1 ) {
            //编辑
            this.$refs.categoriesRef.validate(valid => {
                 if(valid) {
                     editFactors_put(this.polltion).then(res => {
                        if(res.code == 200) {
                            this.$message.success(res.msg)
                            this.pollutionVisible = false
                            this.$emit('getdata')
                            this.$emit('changePollutionVisible', this.pollutionVisible)
                            this.$refs.categoriesRef.resetFields()

                        } else {
                            this.$message.error(res.msg)

                        }
                     })
                }
            }) 
               
                
            
            }
        },
        closeVisible() {
            this.pollutionVisible = false
            //  this.$emit('changePollution', this.pollution)
            this.$emit('changePollutionVisible', this.pollutionVisible)
            this.$refs.categoriesRef.resetFields()
            this.polltion = {}

        },
         //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
              // 查询污染物详细列表
        getDetail() {
              getChargeList({
                parentId: 1001
              }).then(res=> {
                 if(res.code == 200) {
                    this.detailList = res.data

                } else {
                    this.$message.error(res.msg)
                }
            
             })

        },
    }

}
</script>

<style>

</style>